/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { ProgramReferencesAssignmentDto } from './program-references-assignment-dto';
import { ProgramReferencesCountsDto } from './program-references-counts-dto';
 /**
 *
 *
 * @export
 * @interface ProgramReferencesDto
 */
export interface ProgramReferencesDto {

    /**
     * The therapy these references point to
     *
     * @type {JoinEntityDto}
     * @memberof ProgramReferencesDto
     */
    program: JoinEntityDto;

    /**
     * Total assignments created from this therapy
     *
     * @type {number}
     * @memberof ProgramReferencesDto
     * @example 5
     */
    assignments: number;

    /**
     * Distinct members across those assignments
     *
     * @type {number}
     * @memberof ProgramReferencesDto
     * @example 4
     */
    members: number;

    /**
     * Assignments still live (not yet finished)
     *
     * @type {ProgramReferencesCountsDto}
     * @memberof ProgramReferencesDto
     */
    active: ProgramReferencesCountsDto;

    /**
     * Assignments already resolved — history, left untouched
     *
     * @type {ProgramReferencesCountsDto}
     * @memberof ProgramReferencesDto
     */
    frozen: ProgramReferencesCountsDto;

    /**
     * How many OTHER practitioners of the same client own assignments of this therapy. Zero means it stays within the caller’s own work.
     *
     * @type {number}
     * @memberof ProgramReferencesDto
     * @example 1
     */
    otherPractitioners: number;

    /**
     * The assignments, most recent first.
     *
     * @type {Array<ProgramReferencesAssignmentDto>}
     * @memberof ProgramReferencesDto
     */
    items: Array<ProgramReferencesAssignmentDto>;
}
